// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"159f794c","298":"159f794c","418":"159f794c","527":"117f9980","836":"159f794c","861":"159f794c","888":"5a4b3691","903":"10649c49","941":"7330e7e7"}[chunkId] + ".chunk.css";
};